import $ from 'jquery';
import { uniqBy } from 'lodash';
import { getStatePure } from '~src/state';

export const addPagesToExportMenu = async () => {
  const pages = getStatePure('pages');

  let pageIndex = 0;

  let data = pages.map((page) => {
    let id;
    if (page.objectId) {
      id = page.objectId;
    } else {
      id = page.temporaryId;
    }
    pageIndex++;
    return {
      id,
      text: `Pagina ${pageIndex}`,
    };
  });

  const uniqData = uniqBy(data, 'id');

  if (pages.length >= 2) {
    $('#export-selector-pages').show();
    $('#navbar-submenu-export-select-pages').select2({
      data: uniqData,
      tags: true,
      width: '100%',
      theme: 'bootstrap4',
      placeholder: `Tutte le pagine - ${pages.length}`,
      closeOnSelect: false,
      allowHtml: true,
    });
  } else {
    $('#export-selector-pages').hide();
  }
};
